// extracted by mini-css-extract-plugin
module.exports = {"ctf90ob":"ctf90ob","cknq6qk":"cknq6qk"};